import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["min", "max", "disabled", "size", "step", "onChange", "onRawValueChange", "readOnly", "trackStart", "trackEnd", "onKeyDown", "onDragStart", "onDragEnd", "showLabels", "tabIndex", "minLabel", "showTickMarks", "maxLabel", "restrictedAreaTooltip", "defaultValue", "numberInputProps", "numberInputWidth", "value"];
import { Slider } from '../Slider/Slider';
import { NumberInput } from '../NumberInput';
import { Controllable } from '../Controllable';
import { View } from '../../../components/View/View';
import { toPx } from '../../../utils/toPx';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "SliderInput__StyledDiv",
  componentId: "s33zlb-0"
})(({
  $cssStyles
}) => $cssStyles);
export const SliderInputComponent = _ref => {
  let {
      min = 0,
      max = 100,
      disabled = false,
      size = 'default',
      step = 1,
      onChange,
      onRawValueChange,
      readOnly = false,
      trackStart,
      trackEnd,
      onKeyDown,
      onDragStart,
      onDragEnd,
      showLabels,
      tabIndex,
      minLabel,
      showTickMarks,
      maxLabel,
      restrictedAreaTooltip,
      defaultValue,
      numberInputProps,
      numberInputWidth,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledDiv, Object.assign({
    $cssStyles: cssStyles
  }, domProps, {
    children: [/*#__PURE__*/_jsx(View, {
      maxInlineSize: numberInputWidth ? toPx(numberInputWidth) : '25%',
      children: /*#__PURE__*/_jsx(NumberInput, Object.assign({
        marginBlockEnd: "500",
        disabled: disabled,
        max: max,
        min: min,
        value: value,
        onChange: onChange,
        readOnly: readOnly
      }, numberInputProps))
    }), /*#__PURE__*/_jsx(Slider, {
      disabled: disabled,
      max: max,
      min: min,
      value: value,
      onChange: onChange,
      readOnly: readOnly,
      step: step,
      trackStart: trackStart,
      trackEnd: trackEnd,
      onKeyDown: onKeyDown,
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      showLabels: showLabels,
      tabIndex: tabIndex,
      minLabel: minLabel,
      showTickMarks: showTickMarks,
      maxLabel: maxLabel,
      restrictedAreaTooltip: restrictedAreaTooltip,
      defaultValue: defaultValue,
      onRawValueChange: onRawValueChange,
      size: size
    })]
  }));
};
export const SliderInput = Controllable(SliderInputComponent);